<template>
  <el-select v-if="customer" ref="branch" v-model="selected" v-loading="loading" :disabled="disabled ? true : false"
    clearable placeholder="Selecione  uma opção" @change="update()" @clear="clear()">
    <el-option v-for="row of departments" :key="row.id" :label="row.name" :value="row.id"></el-option>
  </el-select>
  <span v-else>Nenhum cliente selecionado</span>
</template>

<script>
import { DepartmentService } from "@/services/department/department.services";
export default {
  name: "DepartmentList",
  props: ["customer", "current", "disabled"],
  data: function () {
    return {
      departments: [],
      selected: "",
      loading: false,
    };
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetchDepartment();
    },
    current: function (v) {
      const vm = this;
      vm.selected = vm.$props.current;
    },
  },
  methods: {
    clear() {
      const vm = this;
      vm.$emit("clear");
    },
    open() { },
    fetchDepartment() {
      const vm = this;
      if (!vm.$props.customer) {
        return false;
      }
      vm.loading = true;
      DepartmentService.listByCustomer(vm.$props.customer)
        .then((response) => {
          vm.departments = response.records;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 500);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchDepartment();
  },
};
</script>